import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import MainLayout from '../../components/common/MainLayout';
import { useEventQueuePermissions } from '../../hooks/useEventQueuePermissions';
import { EventsQueueUnified } from '../../components/events/EventsQueueUnified';
import { useSave } from '../../contexts/WorldContext';

/**
 * Страница задач (теперь save-scoped: /saves/:saveId/tasks).
 */
export const EventQueuePage: React.FC = () => {
  const { saveId } = useParams<{ saveId: string }>();
  const save = useSave();
  const farmId = save.farmId || '';

  const { canViewAllQueue, canViewMyQueue } = useEventQueuePermissions(farmId);

  // Если нет прав ни на что — назад в overview сейва
  if (!canViewAllQueue && !canViewMyQueue) {
    return <Navigate to={`/saves/${saveId}`} replace />;
  }

  return (
    <MainLayout>
      <EventsQueueUnified />
    </MainLayout>
  );
};
